/**
 * 商品表单公共校验规则
 * 用于 addProduct.vue / editProduct.vue / chainProduct/EditProduct.vue
 */

const validateCoverPhoto = (rule, value, callback) => {
  if (!value || value === '') {
    callback(new Error('请上传商品封面'))
  } else {
    callback()
  }
}

const validateContent = (rule, value, callback) => {
  const text = value ? value.replace(/<[^>]*>/g, '').replace(/\s/g, '') : ''
  if (!text) {
    callback(new Error('请填写商品详情'))
  } else {
    callback()
  }
}

export const productFormRules = {
  prodName: [
    { required: true, message: '请填写商品名称', trigger: 'blur' },
    { max: 128, message: '商品名称不能超过128位', trigger: 'blur' }
  ],
  categoryId: [
    { required: true, message: '请选择商品分组', trigger: 'change' }
  ],
  keyword: [
    { required: true, message: '请填写关键词', trigger: 'blur' },
    { max: 256, message: '关键词不能超过256位', trigger: 'blur' }
  ],
  shId: [
    { required: true, message: '请选择仓库', trigger: 'change' }
  ],
  unitName: [
    { required: true, message: '请填写单位', trigger: 'blur' },
    { max: 32, message: '单位不能超过32位', trigger: 'blur' }
  ],
  sort: [
    { required: true, message: '请填写排序', trigger: 'blur' },
    { pattern: /^\d+$/, message: '排序只能填写非负整数', trigger: 'blur' }
  ],
  prodDesc: [
    { required: true, message: '请填写商品简介', trigger: 'blur' },
    { max: 250, message: '商品简介不能超过250位', trigger: 'blur' }
  ],
  coverPhoto: [
    { required: true, validator: validateCoverPhoto, trigger: 'change' }
  ],
  content: [
    { required: true, validator: validateContent, trigger: 'change' }
  ],
  state: [
    { required: true, message: '请选择商品状态', trigger: 'change' }
  ],
  barCode: [
    { max: 15, message: '产品条码不能超过15位', trigger: 'blur' }
  ]
}

/**
 * 校验商品规格表格字段
 * 条形码除外，其他字段均为必填
 * @param {Array} productSpecs 商品规格数组
 * @returns {string|null} 错误信息，校验通过返回 null
 */
export function validateProductSpecs(productSpecs) {
  if (!productSpecs || productSpecs.length === 0) {
    return null
  }

  const requiredFields = [
    { key: 'specName', label: '规格名称' },
    { key: 'stock', label: '库存' },
    { key: 'sales', label: '销量' },
    { key: 'price', label: '销售价格' },
    { key: 'costPrice', label: '成本价' },
    { key: 'ownerPrice', label: '业主价' },
    { key: 'deduction', label: '抵扣金' }
  ]

  for (let i = 0; i < productSpecs.length; i++) {
    const spec = productSpecs[i]
    for (const field of requiredFields) {
      const value = spec[field.key]
      if (value === '' || value === null || value === undefined || Number.isNaN(value)) {
        return '商品信息还有未填写的内容，请填写完整'
      }
    }
  }

  return null
}
